<template>
    <div style="float:right">
    <div class="demo" v-on:click="helpDemo=true"  >
        DEMO
    </div>
    <s-info
            id="addTournoi_demoHelp"
            :open="helpDemo"
            title="Qu'est ce que le mode démo ?"
            @close="close()"
            :big="true"
        >
            Cela vous permet de créer un tournoi sans abonnement et sans crédit.<br/>
            Vous ne pouvez créer qu'un seul tournoi en mode démo par club.<br/>
            Vous pouvez le supprimer et en créer un si vous le souhaitez.<br/>
            En mode démo, c'est le système qui tira au sort un nombre de joueurs aléatoire au démarrage de votre tournoi.<br/>
            L'objectif est que vous puissez tester.
    </s-info>
    </div>
</template>
<style scoped>
    @media screen and (max-width: 420px) {
        .demo { 
            padding-top: 5px;
            padding-bottom: 5px;
            padding-left: 15px;
            padding-right: 15px;
            margin: 3px;
            font-size: 12px;
        }
    }
    @media screen and (min-width: 420px) {
        .demo { 
            padding-top: 5px;
            padding-bottom: 5px;
            padding-left: 15px;
            padding-right: 15px;
            margin: 3px;
        }
    }
    .demo {
        float:right;
        border-radius: 20px;
        background-color: rgb(230, 59, 187);
        color: white;
        font-weight: bolder;
        
    }
    .demo:hover {
        cursor:help;
    }
</style>
<script>
export default {
    data() {
        return {
            helpDemo: false
        }
    },
    methods: {
         close() {
            
             this.helpDemo = false;
         }
    }
}
</script>